/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {theme} from "../Tema";
import logo from '../Recursos/logo_blanco.svg'
import {REDES, SECCIONES, SERVICIOS} from "../Constantes";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";


const Footer = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mb: -5, mt: 5}}
            >

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        backgroundColor: theme.palette.primary.main,
                        borderRadius: 6,
                        p: sCell ? 4 : 8,
                        color: '#fff'
                    }}
                >

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 4}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={200} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Typography>Empieza o sigue tu proceso acompañado de un profesional </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 4}}
                            spacing={1}
                        >

                            {REDES.map((item, index) => (
                                <IconButton sx={{backgroundColor: theme.palette.secondary.main, width: 48, height: 48}}>
                                    <img src={item.img}/>
                                </IconButton>
                            ))}


                        </Grid>

                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 3}}
                        sx={{mt: sCell ? 4 : 0}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontSize: 20,
                                fontWeight: 800,
                                color: theme.palette.secondary.main
                            }}>Servicios</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 2}}
                        >

                            {SERVICIOS.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 500}}>{item}</Typography>
                                </Grid>
                            ))}


                        </Grid>

                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 3}}
                        sx={{mt: sCell ? 4 : 0}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontSize: 20,
                                fontWeight: 800,
                                color: theme.palette.secondary.main
                            }}>Profesionales</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 2}}
                        >

                            {items.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 500}}>{item}</Typography>
                                </Grid>
                            ))}


                        </Grid>

                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 2}}
                        sx={{mt: sCell ? 4 : 0}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 20, fontWeight: 800, color: theme.palette.secondary.main}}>Link
                                Rapidos</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 2}}
                        >

                            {SECCIONES.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 500}}>{item}</Typography>
                                </Grid>
                            ))}


                        </Grid>

                    </Grid>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{borderTop: 1, borderColor: '#fff', color: '#fff', mt: 4}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', mt: 4, mb: sCell ? 4 : 0}}>
                            <Typography>© Creencia Central | 2026 - 2027</Typography>
                        </Grid>

                    </Grid>


                </Grid>


            </Grid>

        </Grid>
    )

}
export default Footer

const items = ['Mauricio Nicolás Battafarano']